import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NotificationsService } from 'src/app/shared/notifications.service';
import { FormControl } from '@angular/forms';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  loading: boolean = false;
  email: string = null;

  constructor(
    public authenticationService: AuthenticationService,
    private notifyService: NotificationsService,
    public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.loading = true;
    this.authenticationService
      .requestPasswordChange(this.email)
      .toPromise()
      .then(
        (response) => {
          this.notifyService.showSuccess(
            `Um email de recuperação de senha foi enviado para a conta.`,
            'Recuperação de senha'
          );
          this.notifyService.showWarning('Por favor, verifique também a sua caixa de spam.', 'Verifique seu email!');
          this.dialogRef.close(true);
          this.loading = false;
        },
        (error) => {
          this.notifyService.showError(
            `Erro ao tentar solicitar recuperação de senha: ${error}`,
            'Recuperação de senha'
          );
          this.loading = false;
        }
      );
  }
}
